<template>
  <div>
    <v-card flat>
      <v-card-title flat>
        <h4 class="subheading ">
          {{ caption }}
        </h4>
      </v-card-title>
      <div v-if="loading">
        <v-loading />
      </div>
      <v-card-text flat>
        <v-wizard
          flat
          ref="wiz"
          :stepObjects="getStepObjects"
          :vertical="false"
          :step="1"
          :e1="wizardStep"
          :key="wizardKey"
          v-if="!loading"
          :highestStep="wizardHighestStep"
        />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import VueSession from "vue-session";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);
Vue.use(VueSession);
import VWizard from "../components/Wizard";
import VLoading from "../components/Loading";
// import * as labor_list from "../plugins/objects/labor_list";
// import * as material_list from "../plugins/objects/material_list";
import * as here from "../plugins/here";
// import * as fun from "../plugins/common";

export default {
  components: { VWizard, VLoading },
  data() {
    return {
      loading: false,
      caption: "Company Settings",
      portal_id: this.$session.get("portal_id"),
      wizardStep: 1,
      wizardKey: 0,
      wizardHighestStep: 0,
      stepObjects: [
        {
          stepName: "company",
          data_object: {
            step_type: "Form",
            object_name: "company",
            title: "Company Details",
            options: {
              excluded: ["email_setup", "default_settings"],
            },
          },

          onLoad: function(data) {
            if (data.company) {
              this.editData = data.company;
            } else {
              this.editData = {};
            }
          },
          getOnFormLoad: function(opt) {
            // console.log(this);
            var f = opt.f;
            var schema = f.schema;
            var addrObj = schema.properties.addresses.properties;
            var c = opt.c;
            console.log(c);
            Object.keys(addrObj).forEach(function(a) {
              var on = {};
              on.input = function(e) {
                console.log(e);
                c.getTimeZone(f.model);
              };

              addrObj[a].properties.address.on = on;
            });
          },
        },
        {
          stepName: "email_setup",
          data_object: {
            step_type: "Form",
            object_name: "company",
            object_key: "email_setup",
            title: "Email Setup",
            options: {
              included: ["email_setup"],
            },
          },

          onLoad: function(data) {
            if (data.company) {
              this.editData = data.company;
            } else {
              this.editData = {};
            }
          },
        },
        // {
        //   stepName: "haul_types",
        //   getFreshData: true,

        //   data_object: {
        //     step_type: "Table",
        //     object_name: "haul_type",
        //     object_key: "haul_type",
        //     title: "Move Types",
        //     all_records: true,
        //     addButtonCaption: "Add Move Type",
        //   },

        // onLoad: function(data) {
        //   if (data.company) {
        //     this.editData = data.company;
        //   } else {
        //     this.editData = {};
        //   }
        // },
        // },
        {
          stepName: "default_settings",
          data_object: {
            step_type: "Form",
            object_name: "company",
            object_key: "default_settings",
            title: "Default Settings",
            options: {
              included: ["default_settings"],
            },
          },

          onLoad: function(data) {
            if (data.company) {
              this.editData = data.company;
            } else {
              this.editData = {};
            }
          },
        },
        // labor_list.getVBind(window.portal_id),
        // material_list.getVBind(window.portal_id),
      ],
    };
  },
  watch: {
    $route: function() {
      this.updateRecord();
    },
  },
  methods: {
    updateWizard() {
      this.wizardKey = !this.wizardKey;
    },
    stepOnMount(data) {
      this.stepObjects.forEach(function(obj) {
        var structure = data.structure;
        obj.data_object.schema = structure[obj.stepName];
        var obj_name = obj.data_object.object_name;

        if (
          obj.data_object.parent_object &&
          obj.data_object.parent_object.object_name
        ) {
          obj_name = obj.data_object.parent_object.object_name;
        }
        obj.data_object.model = data[obj_name];

        if (obj.onLoad) {
          obj.onLoad(data);
        }
      });
      this.loading = false;
      this.updateWizard();
    },
    updateRecord() {
      this.company_id = this.$route.params.id;
      var data = {};
      data.company_id = this.company_id;
      data.data_objects = [];
      this.stepObjects.forEach(function(obj) {
        data.data_objects.push(obj);
      });
      var that = this;
      axios.post(this.serverURL + "/get_company", data).then((response) => {
        that.stepOnMount(response.data);
        if (response.data.company && response.data.company.step) {
          that.wizardStep = response.data.company.step + 1;
          that.wizardHighestStep = that.wizardStep;
        } else {
          that.wizardStep = 1;
          that.wizardHighestStep = 0;
        }
      });
    },
    assignObjectId(_id) {
      this.stepObjects.forEach(function(step) {
        if (!step.data_object._id && !step.data_object.parent_object) {
          step.data_object._id = _id;
        }
      });
    },
    getTimeZone(model) {
      var address = model.addresses[Object.keys(model.addresses)[0]].address;

      here.getTimeZone(address.geo.location.position, function(res) {
        var adminInfo = null;
        try {
          adminInfo = res.Response.View[0].Result[0].Location.AdminInfo;
        } catch (error) {
          console.log(error);
        }

        address.AdminInfo = adminInfo;
      });
    },
    getFormProps(c) {
      var that = this;
      return {
        afterSubmit: function(options) {
          var curObject = this.data_object;

          if (options) {
            curObject._id = options._id;
          }

          var wiz = c.$refs.wiz;
          if (options.formOptions && options.formOptions.nextStep) {
            wiz.move();
            var isHighestStep = that.stepObjects.length <= that.wizardStep;
            if (!isHighestStep) {
              that.wizardHighestStep = that.wizardStep;
              that.wizardStep = that.wizardHighestStep + 1;
            }

            // that.wizardKey = !that.wizardKey;
          }

          if (curObject.assignId) {
            that.assignObjectId(options._id);
          }
          //   this.wizardStep += 1;
          if (curObject.doAfterSubmit) {
            curObject.doAfterSubmit();
          }
        },

        // onFormLoad: function(options) {
        //   if (c.onFormLoad) {
        //   }
        // },
      };
    },
    getAddToTableProp(c, i, s) {
      return {
        beforeGetData: function() {
          var stepObjects = s.stepObjects;

          var _id = stepObjects[0].data_object._id;
          // window.object_id = shipment_id;
          stepObjects[i].data_object.parent_object.object_id = _id;
          stepObjects[i].data_object.parent_object.step = i + 1;
        },
        beforeAddData: function() {
          this.beforeGetData();
        },
      };
    },
    getBeforeSubmit(c, i, obj) {
      return {
        beforeSubmit: function(model, app, formOptions) {
          var data_object = this.data_object;
          data_object.portal_id = app.$session.get("portal_id");
          var n = i + 1;
          if (!model.step || parseInt(model.step) <= n) {
            model.step = n + 1;
          }
          if (data_object.object_name === "company") {
            var stepObjects = c.stepObjects;
            var _id = model._id || stepObjects[0].data_object.model._id;
            data_object._id = _id;
            model._id = _id;
          }
          if (formOptions.nextStep) {
            model.step = n;
          }

          if (data_object.beforeAddData) {
            var options = {
              model: model,
              data_object: data_object,
              app: app,
              c: c,
            };
            data_object.beforeAddData(options);
          }
          // if (this.data_object.stopSubmit) {
          //   return true;
          // }
        },
        beforeGetData: function(f) {
          if (obj.getBeforeGetData) {
            var options = {
              data_object: obj,
              f: f,
              c: c,
            };
            obj.getBeforeGetData(options);
          }
        },
        onFormLoad: function(f) {
          if (obj.getOnFormLoad) {
            var options = {
              f: f,

              c: c,
            };
            obj.getOnFormLoad(options);
          }
        },
        onLoadComponent: function(f) {
          if (obj.getOnLoadComponent) {
            var options = {
              f: f,

              c: c,
            };
            obj.getOnLoadComponent(options);
          }
        },
      };
    },

    getCurrentDate() {
      var d = new Date();
      var dd = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDay();
      return dd;
    },
  },
  computed: {
    getStepObjects() {
      var that = this;
      var p = null;

      this.stepObjects.forEach(function(obj, i) {
        // if (obj.onFormLoad) {

        // }

        var prop = that.getBeforeSubmit(that, i, obj);
        Object.assign(obj, prop);
        // if (obj.data_object.step_type === "Form") {
        p = that.getFormProps(that);
        Object.assign(obj, p);
        // }
        // p = that.getAddToTableProp(that, i, that);
        // Object.assign(obj, p);

        // }
        if (obj.data_object.step_type === "AddToTable") {
          p = that.getAddToTableProp(that, i, that);
          Object.assign(obj, p);
        }
      });

      return that.stepObjects;
    },
  },
  mounted() {
    this.portal_id = this.$session.get("portal_id");
    window.portal_id = this.$session.get("portal_id");

    this.updateRecord();
  },
};
</script>
